var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-bgc"},[_c('img',{staticClass:"empty-img",attrs:{"src":require("../../images/empty-learning.png"),"alt":""}}),_c('p',{staticClass:"empty-p"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }